/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ptc.pm.collaborators.title': 'Tus colaboradores',
  'ptc.pm.error-heading': 'Algo ha ido mal',
  'ptc.pm.error-image-alt-text': 'Un robot roto y varias personas ocupadas intentando arreglarlo.',
  'ptc.pm.error-text':
    'Realizamos un seguimiento de estos errores, pero ponte en contacto con nosotros si actualizar no soluciona el problema',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} miembro} other {{memberCount,number} miembros}}',
  'ptc.pm.people': 'Personas',
  'ptc.pm.teams': 'Equipos',
  'ptc.pm.view-your-profile': 'Ver tu perfil',
  'ptc.pm.your-teams.title': 'Tus equipos',
};
